import type { CommonPackageOptions } from '@/core/common';
import type { Base } from '@/proto/base';
import type { BaseOptions } from '@/config/types';

import { CommonPackage as BaseCommonPackage } from '@/core/common';
import { isInApp, getResolution, getPositiveInteger } from '@/util';
import { getCookie } from '@/util/cookie';
import { getUAInfo, getDefaultKpn } from '@/util/ua';
import { getModel } from '@/util/device-detect';
import {
    getBridgeNormalIncrementId,
    getBridgeCustomIncrementId,
    getChannelIncrementId,
    getV2EventIncrementId,
} from '@/util/increment-id';
import { generateDID } from '@/util/uuid';

let platformPB: number = 0;

function platform(): number {
    try {
        const osName = getUAInfo().os.name;
        if (!osName) {
            return platformPB = 0;
        }
        if (osName === 'Android') {
            return platformPB = isInApp() ? 6 : 8;
        }
        if (osName === 'iOS') {
            return platformPB = isInApp() ? 7 : 9;
        }
        return platformPB = 10;
    } catch (err) {
        return 0;
    }
}

function network() {
    let networkType = 'unknown';
    const navigator = window?.navigator;
    const connection = navigator?.connection || navigator?.mozConnection || navigator?.webkitConnection;
    if (connection) {
        networkType = connection.type || connection.effectiveType;
    }
    return networkType;
}
export class CommonPackage extends BaseCommonPackage {
    additional_seq_id_package?: Base.AdditionalSeqIdPackage;
    constructor(options: BaseOptions) {
        super({
            platform: platform(),
            container: platformPB === 10 ? 'WEB' : 'H5',
            version_name: isInApp() && getCookie('appver', undefined, true) || '',  // 宿主客户端版本号
            network_type: network(),
            device_id: generateDID(),
            user_id: getCookie('userId'),
            global_id: isInApp() && getCookie('egid') || '',
            app_package: {
                language: navigator.language,
            },
            device_package: {
                os_version: getUAInfo().os.version,
                model: getModel(),
                ua: navigator.userAgent,
            },
            ...options
        });
        Object.assign(this.h5_extra_attr, {
            host_product: getDefaultKpn(),
            resolution: getResolution(),
            screen_width: getPositiveInteger(screen.width),
            screen_height: getPositiveInteger(screen.height),
            device_pixel_ratio: window.devicePixelRatio || 1,
            domain: window.location.origin,
            fromIframe: window?.self !== window?.top,
        }, options.h5_extra_attr);
        delete this.location_package;
    }

    getVersionName() {
        return this.app_package.version_name;
    }

    /**
    * 更新 commonPackage 信息
    * @param options
    * @returns
    */
    override update(options: CommonPackageOptions | BaseOptions) {
        super.update(options);
        // 主站版本号较为严格，直接通过版本名读取
        const version_name = this.app_package.version_name;
        if (typeof version_name === 'string') {
            const lastDotIndex = version_name.lastIndexOf('.');
            this.app_package.version_code = + version_name.slice(lastDotIndex + 1) || 0;
            this.h5_extra_attr.app_version_name = version_name;
        }

    }
    // v2 丢失统计
    setAdditionalSeqIdPackage(eventType: string) {
        this.additional_seq_id_package = {
            channel: 3,
            channel_seq_id: getChannelIncrementId('NORMAL'),
            custom_type: eventType,
            custom_seq_id: getV2EventIncrementId(eventType)
        };
    }
    // 用于统计桥接丢失率
    increaseH5SeqId(isCustom?: Boolean) {
        this.h5_extra_attr.client_timestamp = getPositiveInteger(new Date().valueOf());
        this.h5_extra_attr.seq_id = isCustom ? getBridgeCustomIncrementId() : getBridgeNormalIncrementId();
    }
}
